import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../../../../../../app/common-components/ButtonComponent";
import CustomSelectDropDown from "../../../../../../app/common-components/CustomSelectDropDown";
import Spinners from "../../../../../../app/common-components/Spinner";
import {
  decrypt,
  useCommonAlert,
} from "../../../../../../app/utilities/helpers";
import {
  getConfigJiraIssueTypeList,
  getConfigJiraPriorityList,
  getConfigJiraStatusList,
  getJiraIssueTypeSave,
  getJiraPrioritySave,
  getJiraStatusSave,
} from "../../ToolsSlice";
import "./styles.css";
import {
  ACTIVE_TAB_VALUES,
  CATEGORY_TYPE_LOWERCASE,
  CATEGORY_TYPES,
  DISPLAY_LABELS,
} from "./Utilities/Identifiers";

const CategoriesConfig = (props) => {
  const {
    jiraIssuetypeLoading,
    jiraPriorityLoading,
    jiraStatusLoading,
    IssueTypeCatagorizedData,
    PriorityCatagorizedData,
    StatusCatagorizedData,
  } = useSelector((state) => state.toolsApi);

  // Get the appropriate loading state based on active tab
  const jiraLoading =
    props?.activeTab === ACTIVE_TAB_VALUES.ISSUE_TYPE
      ? jiraIssuetypeLoading
      : props?.activeTab === ACTIVE_TAB_VALUES.PRIORITY
        ? jiraPriorityLoading
        : jiraStatusLoading;

  const apidata = props?.ApiData;
  const dispatch = useDispatch();

  // Map activeTab to API key
  const mapToApiKey = (tab) => {
    if (!tab) {
      return null;
    }
    const t = tab.toString().toLowerCase();
    if (t.includes(CATEGORY_TYPE_LOWERCASE.ISSUE)) {
      return CATEGORY_TYPES.ISSUE_TYPE;
    }
    if (t.includes(CATEGORY_TYPE_LOWERCASE.PRIORITY)) {
      return CATEGORY_TYPES.PRIORITY;
    }
    if (t.includes(CATEGORY_TYPE_LOWERCASE.STATUS)) {
      return CATEGORY_TYPES.STATUS;
    }
    return tab;
  };

  // Extracting options from API data (NEW STRUCTURE)
  const extractedOptions = Object.keys(apidata).map((key) => {
    const data = apidata[key];
    // Find uncategorized items from the new array structure
    const uncategorizedData = Array.isArray(data)
      ? data.find((item) => item?.categoryName === CATEGORY_TYPES.UNCATEGORIZED)
      : null;

    // Extract items based on type
    let items = [];
    if (uncategorizedData) {
      if (key === CATEGORY_TYPES.ISSUE_TYPE) {
        items = uncategorizedData.issueTypes || [];
      } else if (key === CATEGORY_TYPES.PRIORITY) {
        items = uncategorizedData.priorityType || [];
      } else if (key === CATEGORY_TYPES.STATUS) {
        items = uncategorizedData.statusType || [];
      }
    }

    return {
      label:
        key === CATEGORY_TYPES.ISSUE_TYPE ? DISPLAY_LABELS.ISSUE_TYPE : key,
      value: items,
      originalKey: key,
    };
  });

  const { callCommonAlert, hideCommonAlert } = useCommonAlert();

  const [selectedOptionerrorMessage, setselectedOptionErrorMessage] =
    useState("");
  const [selectedOptionstate, setselectedOptionstate] = useState(false);

  //valiadtion
  const [CategorynameerrorMessage, setCategorynameErrorMessage] = useState("");
  const [errorselection, seterrorselection] = useState(false);
  const [isClickApply, setClickApply] = useState(false);

  const { common } = useSelector((state) => state);
  const { userName } = common.loggedUser;
  const encodeduserName = decrypt(userName);

  const getDefaultOption = () => {
    if (!props.activeTab || !extractedOptions.length) {
      return extractedOptions[0] || null;
    }
    const matchedOption = extractedOptions.find(
      (opt) => opt.originalKey.toLowerCase() === props.activeTab.toLowerCase()
    );
    return matchedOption || extractedOptions[0] || null;
  };

  // State for selected category
  const [selectedOption, setSelectedOption] = useState(getDefaultOption());
  const [items1, setItems1] = useState([]);
  const [items2, setItems2] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [selectedRightCategory, setSelectedRightCategory] = useState(""); // Stores selected category for the right container.
  const [rightDropdownOptions, setRightDropdownOptions] = useState([]); // Stores options for the right dropdown

  const [originalItems2, setOriginalItems2] = useState([]);

  const [uncategorizedSearch, setUncategorizedSearch] = useState("");
  const [categorizedSearch, setCategorizedSearch] = useState("");

  useEffect(() => {
    if (items2.length > 0 && originalItems2.length === 0) {
      setOriginalItems2([...items2]); // Ensures correct reference for comparison
    }
  }, [items2]);

  const [hasDragged, setHasDragged] = useState(false);

  useEffect(() => {
    if (!selectedOption?.label) {
      return;
    }

    const selectedData = apidata[selectedOption.originalKey];

    // Find uncategorized data from new array structure
    const uncategorizedData = Array.isArray(selectedData)
      ? selectedData.find(
        (item) => item?.categoryName === CATEGORY_TYPES.UNCATEGORIZED
      )
      : null;

    // Extract items based on type
    let uncategorizedItems = [];
    if (uncategorizedData) {
      let items = [];
      if (selectedOption.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
        items = uncategorizedData.issueTypes || [];
      } else if (selectedOption.originalKey === CATEGORY_TYPES.PRIORITY) {
        items = uncategorizedData.priorityType || [];
      } else if (selectedOption.originalKey === CATEGORY_TYPES.STATUS) {
        items = uncategorizedData.statusType || [];
      }

      uncategorizedItems = items.map((item, index) => ({
        id: `${selectedOption.label}-uncategorized-${index}`,
        content: item,
      }));
    }

    setItems1(uncategorizedItems);
    setItems2([]); // Reset mapped list
    setSelectedItems([]);
    setOriginalItems2([]);

    // Get categorized data based on SELECTED OPTION (not activeTab)
    let categorizedData;
    if (selectedOption.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
      categorizedData = IssueTypeCatagorizedData;
    } else if (selectedOption.originalKey === CATEGORY_TYPES.PRIORITY) {
      categorizedData = PriorityCatagorizedData;
    } else if (selectedOption.originalKey === CATEGORY_TYPES.STATUS) {
      categorizedData = StatusCatagorizedData;
    }

    // Extract category names from Redux data (excluding Uncategorized)
    let categorizedOptions = [];
    if (Array.isArray(categorizedData)) {
      categorizedOptions = categorizedData
        .filter((item) => item?.categoryName !== CATEGORY_TYPES.UNCATEGORIZED)
        .sort((a, b) => a.priorityOrder - b.priorityOrder)
        .map((item) => item?.categoryName);
    }

    const dropdownFormatted = categorizedOptions.map((categoryName) => ({
      label: categoryName,
      value: categoryName,
    }));

    setRightDropdownOptions(dropdownFormatted);
    setSelectedRightCategory(""); // Reset current group selection
  }, [
    selectedOption,
    apidata,
    IssueTypeCatagorizedData,
    PriorityCatagorizedData,
    StatusCatagorizedData,
  ]);

  // Handle dropdown change(left side)
  const handleOnChange = (selected) => {
    setSelectedOption(selected);
    const selectedData = apidata[selected.originalKey];

    // Only call API if different from active tab
    const activeTabKey = mapToApiKey(props.activeTab);
    if (selected?.originalKey && selected.originalKey !== activeTabKey) {
      if (selected.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
        dispatch(getConfigJiraIssueTypeList());
      } else if (selected.originalKey === CATEGORY_TYPES.PRIORITY) {
        dispatch(getConfigJiraPriorityList());
      } else if (selected.originalKey === CATEGORY_TYPES.STATUS) {
        dispatch(getConfigJiraStatusList());
      }
    }

    // Find uncategorized data from new array structure
    const uncategorizedData = Array.isArray(selectedData)
      ? selectedData.find(
        (item) => item?.categoryName === CATEGORY_TYPES.UNCATEGORIZED
      )
      : null;

    // Extract items based on type
    let uncategorizedItems = [];
    if (uncategorizedData) {
      let items = [];
      if (selected.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
        items = uncategorizedData.issueTypes || [];
      } else if (selected.originalKey === CATEGORY_TYPES.PRIORITY) {
        items = uncategorizedData.priorityType || [];
      } else if (selected.originalKey === CATEGORY_TYPES.STATUS) {
        items = uncategorizedData.statusType || [];
      }

      uncategorizedItems = items.map((item, index) => ({
        id: `${selected.label}-uncategorized-${index}`,
        content: item,
      }));
    }

    setItems1(uncategorizedItems);
    setItems2([]);
    setSelectedItems([]);
    setOriginalItems2([]);
    setSelectedRightCategory("");
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    setHasDragged(true);

    const { source, destination } = result;

    // Same list reordering
    if (source.droppableId === destination.droppableId) {
      const list =
        source.droppableId === "droppable-1" ? [...items1] : [...items2];
      const [moved] = list.splice(source.index, 1);
      list.splice(destination.index, 0, moved);

      source.droppableId === "droppable-1" ? setItems1(list) : setItems2(list);
    }
    // Moving between lists
    else {
      const sourceList =
        source.droppableId === "droppable-1" ? [...items1] : [...items2];
      const destList =
        destination.droppableId === "droppable-1" ? [...items1] : [...items2];

      const [moved] = sourceList.splice(source.index, 1);
      destList.splice(destination.index, 0, moved);

      if (source.droppableId === "droppable-1") {
        setItems1(sourceList);
        setItems2(destList);
      } else {
        setItems1(destList);
        setItems2(sourceList);
      }
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const moveSelectedItems = (fromItems, toItems, setFromItems, setToItems) => {
    if (selectedItems.length === 0) {
      callCommonAlert("error", "Please select items to move.");
      hideCommonAlert();
      {
        return;
      }
    }

    const movingItems = fromItems.filter((item) =>
      selectedItems.includes(item.id)
    );
    const remainingItems = fromItems.filter(
      (item) => !selectedItems.includes(item.id)
    );

    setFromItems(remainingItems);
    setToItems([...toItems, ...movingItems]);
    setSelectedItems([]); // Clear selection
  };

  //rightside dropdown
  const handleCategorizedChange = (selected) => {
    setSelectedRightCategory(selected.value);
    seterrorselection(false);
    setCategorynameErrorMessage("");

    if (!selectedOption) {
      return;
    }

    const selectedData = apidata[selectedOption.originalKey];

    // Get categorized data based on SELECTED OPTION (not activeTab)
    let categorizedDataList;
    if (selectedOption.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
      categorizedDataList = IssueTypeCatagorizedData;
    } else if (selectedOption.originalKey === CATEGORY_TYPES.PRIORITY) {
      categorizedDataList = PriorityCatagorizedData;
    } else if (selectedOption.originalKey === CATEGORY_TYPES.STATUS) {
      categorizedDataList = StatusCatagorizedData;
    }

    // Find the selected category from categorized data
    const selectedCategory = Array.isArray(categorizedDataList)
      ? categorizedDataList.find((cat) => cat?.categoryName === selected.value)
      : null;

    // Reset left (Uncategorized) list
    const uncategorizedData = Array.isArray(selectedData)
      ? selectedData.find(
        (item) => item?.categoryName === CATEGORY_TYPES.UNCATEGORIZED
      )
      : null;

    let uncategorizedItems = [];
    if (uncategorizedData) {
      let items = [];
      if (selectedOption.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
        items = uncategorizedData.issueTypes || [];
      } else if (selectedOption.originalKey === CATEGORY_TYPES.PRIORITY) {
        items = uncategorizedData.priorityType || [];
      } else if (selectedOption.originalKey === CATEGORY_TYPES.STATUS) {
        items = uncategorizedData.statusType || [];
      }

      uncategorizedItems = items.map((item, index) => ({
        id: `${selectedOption.label}-uncategorized-${index}`,
        content: item,
      }));
    }
    setItems1(uncategorizedItems);

    // Reset right (Categorized) list
    let categorizedItems = [];
    if (selectedCategory) {
      let items = [];
      if (selectedOption.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
        items = selectedCategory.issueTypes || [];
      } else if (selectedOption.originalKey === CATEGORY_TYPES.PRIORITY) {
        items = selectedCategory.priorityType || [];
      } else if (selectedOption.originalKey === CATEGORY_TYPES.STATUS) {
        items = selectedCategory.statusType || [];
      }

      categorizedItems = items.map((item, index) => ({
        id: `${selectedOption.originalKey}-${selected.value}-${index}`,
        content: item,
      }));
    }
    setItems2(categorizedItems);
    setOriginalItems2(categorizedItems);
    setSelectedItems([]);
  };

  const handlesaveclick = () => {
    setClickApply(true);
    if (!selectedRightCategory) {
      seterrorselection(true);
      setCategorynameErrorMessage("Please select a mapped group.");
      {
        return;
      }
    }

    // Get the categorized data based on SELECTED OPTION (not activeTab)
    let categorizedData;
    if (selectedOption?.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
      categorizedData = IssueTypeCatagorizedData;
    } else if (selectedOption?.originalKey === CATEGORY_TYPES.PRIORITY) {
      categorizedData = PriorityCatagorizedData;
    } else if (selectedOption?.originalKey === CATEGORY_TYPES.STATUS) {
      categorizedData = StatusCatagorizedData;
    }

    // Find the category to get configId and priority
    const currentCategory = Array.isArray(categorizedData)
      ? categorizedData.find(
        (cat) => cat?.categoryName === selectedRightCategory
      )
      : null;

    const configId = currentCategory?.configId || null;
    const priorityOrder = currentCategory?.priorityOrder || 0;

    let itemIds;
    if (selectedOption?.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
      itemIds = items2
        .map((i) => i.content?.issueTypeId)
        .filter((id) => id != null);
    } else if (selectedOption?.originalKey === CATEGORY_TYPES.PRIORITY) {
      itemIds = items2
        .map((i) => i.content?.priorityId)
        .filter((id) => id != null);
    } else if (selectedOption?.originalKey === CATEGORY_TYPES.STATUS) {
      itemIds = items2
        .map((i) => i.content?.statusId)
        .filter((id) => id != null);
    }

    // Build payload based on SELECTED OPTION (not activeTab)
    let payload;
    let saveApiCall;

    if (selectedOption?.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
      payload = {
        configId: configId,
        priority: priorityOrder,
        categoryName: selectedRightCategory,
        issueTypeIds: itemIds,
      };
      saveApiCall = dispatch(getJiraIssueTypeSave(payload));
    } else if (selectedOption?.originalKey === CATEGORY_TYPES.PRIORITY) {
      payload = {
        configId: configId,
        priority: priorityOrder,
        categoryName: selectedRightCategory,
        priorityIds: itemIds,
      };
      saveApiCall = dispatch(getJiraPrioritySave(payload));
    } else if (selectedOption?.originalKey === CATEGORY_TYPES.STATUS) {
      payload = {
        configId: configId,
        priority: priorityOrder,
        categoryName: selectedRightCategory,
        statusIds: itemIds,
      };
      saveApiCall = dispatch(getJiraStatusSave(payload));
    }

    saveApiCall.then((data) => {
      if (
        data.payload.statusCodeValue >= 200 &&
        data.payload.statusCodeValue < 300
      ) {
        callCommonAlert(
          "success",
          data?.payload?.body || "Updated Successfully"
        );

        setTimeout(() => {
          hideCommonAlert();
          props.handleClose();
          // Dispatch after popup closes based on SELECTED OPTION (not activeTab)
          if (selectedOption?.originalKey === CATEGORY_TYPES.ISSUE_TYPE) {
            dispatch(getConfigJiraIssueTypeList());
          } else if (selectedOption?.originalKey === CATEGORY_TYPES.PRIORITY) {
            dispatch(getConfigJiraPriorityList());
          } else if (selectedOption?.originalKey === CATEGORY_TYPES.STATUS) {
            dispatch(getConfigJiraStatusList());
          }
        }, 2000); // 3 seconds
      } else if (data?.payload?.body) {
        callCommonAlert("error", data?.payload?.body);
        hideCommonAlert();
      } else if (data.error) {
        callCommonAlert(
          "error",
          "Error occurred while updating Categorize Please try again"
        );
        hideCommonAlert();
      }
    });
  };

  return (
    <>
      {jiraLoading ? (
        <Spinners />
      ) : (
        <>
          <h6>Map</h6>
          <Row className="mx-3 mt-3">
            {/* <h4 className="Noborder">See results in your view based on the filters you select here.</h4>
                    <br /> */}

            <Col md={5}>
              <h5 className="Noborder">Select Category</h5>
              <CustomSelectDropDown
                options={extractedOptions}
                onChange={handleOnChange}
                value={selectedOption}
                containerClassName="custom-input-field"
                error={selectedOptionstate}
                errorMessage={selectedOptionerrorMessage}
              />
            </Col>
            <Col md={2}></Col>
            <Col md={5}>
              <h5 className="Noborder">Select Group </h5>
              <CustomSelectDropDown
                noOptionSorting={true}
                options={rightDropdownOptions}
                onChange={handleCategorizedChange}
                value={selectedRightCategory}
                containerClassName="custom-input-field"
                error={errorselection}
                errorMessage={CategorynameerrorMessage}
              />
            </Col>
          </Row>
          <Row className="mx-3 mt-3">
            <DragDropContext onDragEnd={onDragEnd}>
              <Col md={5}>
                <h5 className="Noborder">Unmapped</h5>
                <div className="boxStyle">
                  <div className="searchBoxStyle">
                    <input
                      type="text"
                      placeholder="Search"
                      className="inputStyle"
                      onChange={(e) => setUncategorizedSearch(e.target.value)}
                    />
                  </div>
                  <Droppable
                    droppableId="droppable-1"
                    isDropDisabled={!selectedRightCategory}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className={`listStyle dropAdjust ${!selectedRightCategory ? "disabled-container" : ""
                          }`}
                      >
                        {items1
                          .filter((item) => {
                            const itemName =
                              item.content?.name || item.content || "";
                            return itemName
                              .toLowerCase()
                              .includes(uncategorizedSearch.toLowerCase());
                          })
                          .map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                              isDragDisabled={!selectedRightCategory}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className={`item ${snapshot.isDragging ? "dragging" : ""
                                    }`}
                                >
                                  <input
                                    type="checkbox"
                                    disabled={!selectedRightCategory}
                                    checked={selectedItems.includes(item.id)}
                                    onChange={() =>
                                      handleCheckboxChange(item.id)
                                    }
                                  />{" "}
                                  {item.content?.name || item.content}
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </div>
              </Col>

              <Col md={2} className="arrowContainer">
                <Button
                  variant="light"
                  className="arrowButtonStyle"
                  onClick={() =>
                    moveSelectedItems(items1, items2, setItems1, setItems2)
                  }
                  disabled={!selectedRightCategory}
                >
                  →
                </Button>
                <div style={{ height: "1px" }}></div>
                <Button
                  variant="light"
                  className="arrowButtonStyle"
                  onClick={() =>
                    moveSelectedItems(items2, items1, setItems2, setItems1)
                  }
                  disabled={!selectedRightCategory}
                >
                  ←
                </Button>
              </Col>

              <Col md={5}>
                {/* <h5 className="Noborder">Categorized {items2?.length != originalItems2.length?<span> Hi</span>:""}</h5> */}

                <h5 className="Noborder">Mapped</h5>

                {/* {JSON.stringify(items2) === JSON.stringify(originalItems2) && isClickApply && (
    <p className="errormeaasge">No changes detected</p>
)} */}

                <div className="boxStyle">
                  <div className="searchBoxStyle">
                    <input
                      type="text"
                      placeholder="Search"
                      className="inputStyle"
                      onChange={(e) => setCategorizedSearch(e.target.value)}
                    />
                  </div>
                  <Droppable droppableId="droppable-2">
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="listStyle dropAdjust"
                      >
                        {items2.length === 0 && (
                          <div
                            className="empty-placeholder"
                            style={{
                              padding: "20px",
                              textAlign: "center",
                              color: "#aaa",
                            }}
                          >
                            {/* Drag items here */}
                          </div>
                        )}
                        {items2
                          .filter((item) => {
                            const itemName =
                              item.content?.name || item.content || "";
                            return itemName
                              .toLowerCase()
                              .includes(categorizedSearch.toLowerCase());
                          })
                          .map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className={`item ${snapshot.isDragging ? "dragging" : ""
                                    }`}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedItems.includes(item.id)}
                                    onChange={() =>
                                      setSelectedItems((prev) =>
                                        prev.includes(item.id)
                                          ? prev.filter((i) => i !== item.id)
                                          : [...prev, item.id]
                                      )
                                    }
                                  />{" "}
                                  {item.content?.name || item.content}
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </div>
              </Col>
            </DragDropContext>
          </Row>
          <div
            className="btnswrap d-flex justify-content-end"
            style={{ gap: "5px" }}
          >
            <ButtonComponent
              text="Cancel"
              className={"cancelBtnStyle btn btn-primary"}
              onClick={props.handleClose}
            />
            <ButtonComponent
              text="Apply"
              className={"btnStyle btn btn-primary"}
              onClick={() => handlesaveclick()}
            />
          </div>
        </>
      )}
    </>
  );
};

CategoriesConfig.propTypes = {
  ApiData: PropTypes.shape({
    Status: PropTypes.arrayOf(
      PropTypes.shape({
        configId: PropTypes.number,
        categoryName: PropTypes.string,
        priorityOrder: PropTypes.number,
        configurationtype: PropTypes.string,
        statusType: PropTypes.arrayOf(
          PropTypes.shape({
            statusId: PropTypes.number,
            name: PropTypes.string,
          })
        ),
      })
    ),
    IssueType: PropTypes.arrayOf(
      PropTypes.shape({
        configId: PropTypes.number,
        categoryName: PropTypes.string,
        priorityOrder: PropTypes.number,
        configurationtype: PropTypes.string,
        issueTypes: PropTypes.arrayOf(
          PropTypes.shape({
            issueTypeId: PropTypes.number,
            name: PropTypes.string,
          })
        ),
      })
    ),
    Priority: PropTypes.arrayOf(
      PropTypes.shape({
        configId: PropTypes.number,
        categoryName: PropTypes.string,
        priorityOrder: PropTypes.number,
        configurationtype: PropTypes.string,
        priorityType: PropTypes.arrayOf(
          PropTypes.shape({
            priorityId: PropTypes.number,
            name: PropTypes.string,
          })
        ),
      })
    ),
  }).isRequired,
  activeTab: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default CategoriesConfig;
